import DomainRecord from './DomainRecord'
import Employee from './Employee'
export class SaveDomainRecordsRequest {
    TableName: String;
    Records: DomainRecord[];
    SavedByEmployee: Employee;
}

export default SaveDomainRecordsRequest;